import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Slider from 'rc-slider';
import classNames from 'classnames';
import { LeftCevronIcon, RightCevronIcon } from 'images/common';
import { maxBy } from 'lodash';
import 'rc-slider/assets/index.css';

import messages from 'utils/messages';
import { FILTER_TYPE } from '../constants';

class MultiRange extends React.Component {
  state = {
    filterValue: [],
    value1: 0,
    value2: 0
  }

  onApply = () => {
    const { filterValue } = this.state;
    const { name, onFilterApply } = this.props;

    onFilterApply(name, filterValue, FILTER_TYPE.SEARCH);
  }

  componentDidMount() {
    const { columns } = this.props;

    const getMaxRange = maxBy(columns, o => o.label) || { label: 0 };

    this.setState({ maxValue: getMaxRange.label, filterValue: [getMaxRange.label] });
    this.setState({ value1: 0, value2: getMaxRange.label });

    this.setState({ filterValue: [0, getMaxRange.label] });
    document.addEventListener('keydown', this.onEnter, false);
  }

  onEnter = (event) => {
    if (event.key === 'Enter') {
      // on Esc button click it should close popup
      this.onApply();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEnter, false);
  }

  onChange = (value) => {
    this.setState({ value1: value[0], value2: value[1], filterValue: value });
  }

  onChangeInput1 = (e) => {
    const newValue = Number(e.target.value)
    const updateValue = [newValue, this.state.filterValue[1]]
    this.setState({ value1: newValue, filterValue: updateValue });
  }

  onChangeInput2 = (e) => {
    const newValue = Number(e.target.value)
    const updateValue = [this.state.filterValue[0], newValue]
    this.setState({ value2: newValue, filterValue: updateValue });
  }

  render() {
    const {
      title, customClass, color, disabled, columns,
    } = this.props;
    const customInputClass = `range-slider range-slider--multi text-field text-field_nolabel text-field_${customClass}`;
    const getMaxRange = maxBy(columns, o => o.label) || { label: 0 };

    const inputClass = classNames({
      'text-field__range': true,
      'text-field__input': true,
      'text-field__input_filled': true,
    });

    const handleSliderClass = classNames('slider-icon', {
      [color]: color,
      disabled,
    });

    return (
      <div className="text-field__range_container">
        <div className="filters-bar__heading">{title}</div>
        <div className="filters-bar__range filters-bar__range--multi">
          <input
            type="text"
            maxLength={4}
            value={this.state.value1}
            className={inputClass}
            onChange={this.onChangeInput1}
          />
          <div className='range-slider__input-divider' />
          <input
            type="text"
            maxLength={4}
            value={this.state.value2}
            className={inputClass}
            onChange={this.onChangeInput2}
          />
        </div>
        <div className={customInputClass}>
          <Slider
            range
            min={0}
            max={getMaxRange.label}
            onChange={val => this.onChange(val)}
            value={[this.state.value1, this.state.value2]}
            defaultValue={[this.state.value1, this.state.value2]}
            tipFormatter={value => `$ ${value}`}
            handleRender={(node, props) => {
              return React.cloneElement(node, {
                ...props,
                children: (
                  <div className='rc-slider-handle__icon'>
                    {props.index === 0 && <LeftCevronIcon className='rc-slider-handle__chevron' />}
                    {props.index === 1 && <RightCevronIcon />}
                  </div>
                )
              })
            }}

          />
        </div>
        <hr className="mt_100" />
        <button type="button" className={`filters-bar__apply ${customClass}`} onClick={this.onApply}>
          <FormattedMessage {...messages.apply} />
        </button>
      </div>
    );
  }
}

MultiRange.propTypes = {
  name: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onFilterApply: PropTypes.func,
  customClass: PropTypes.string,
};

export default MultiRange;
